// Simple access control for Compliance feature during testing

// Entries MUST be lowercase -- every lookup below compares against
// String(userEmail).toLowerCase(), so a mixed-case entry can never match.
export const COMPLIANCE_ADMINS = ['su@oquli.ca', 'pr@oquli.ca', 'shivani101201@gmail.com', 'pr@oquli.onmicrosoft.com'];

// ── Plan-tier helpers (from Company.planKey: 'starter' | 'studio' | 'firm') ──
// Studio and Firm include the Compliance Tracker / Scanner; Starter does not.
// Used to make the onboarding tour + checklist tier-dependent.
export const COMPLIANCE_PLAN_KEYS = ['studio', 'firm'];

export function planHasCompliance(planKey) {
  return COMPLIANCE_PLAN_KEYS.includes(String(planKey || '').toLowerCase());
}

// Studio and Firm include multi-user Team & Access; Starter is single-user.
export const TEAM_PLAN_KEYS = ['studio', 'firm'];

export function planHasTeamAccess(planKey) {
  return TEAM_PLAN_KEYS.includes(String(planKey || '').toLowerCase());
}

// Toggle to enable for all users once ready for production rollout
export const COMPLIANCE_ENABLED_FOR_ALL = false;

export function hasComplianceAccess(userEmail) {
  if (!userEmail) return false;
  try {
    return COMPLIANCE_ADMINS.includes(String(userEmail).toLowerCase());
  } catch {
    return false;
  }
}

export function shouldShowCompliance(userEmail) {
  if (COMPLIANCE_ENABLED_FOR_ALL) return true;
  return hasComplianceAccess(userEmail);
}

export const REVIEW_ENABLED_FOR_ALL = false;

export function shouldShowReview(userEmail) {
  if (REVIEW_ENABLED_FOR_ALL) return true;
  return hasReviewAccess(userEmail) || hasComplianceAccess(userEmail);
}


// Restricted access for Review Table. Lowercase-only, as above.
export const REVIEW_ADMINS = ['pr@oquli.onmicrosoft.com'];

export function hasReviewAccess(userEmail) {
  if (!userEmail) return false;
  try {
    return REVIEW_ADMINS.includes(String(userEmail).toLowerCase());
  } catch {
    return false;
  }
}

/**
 * TEMPORARY (dd dev): load linked drawing PDFs in Review when geometry/IR is empty.
 * Does not run vector extraction. Set false (or delete) once IR pipeline is gated for pilot.
 */
export const REVIEW_PDF_ONLY_FALLBACK = true;

export function hasClassifierAccess(email) {
  return String(email || '').trim().toLowerCase() === 'su@oquli.ca';
}


// Restricted access for Requirements Lab 
export const REQUIREMENTS_ADMINS = [
  'su@oquli.ca', 'dd@oquli.ca', 'pr@oquli.ca', 'shivaniuppeuni@gmail.com'
];

// Toggle to enable for all users later
export const REQUIREMENTS_ENABLED_FOR_ALL = false;

export function hasRequirementsAccess(userEmail) {
  if (!userEmail) return false;
  try {
    return REQUIREMENTS_ADMINS.includes(String(userEmail).toLowerCase());
  } catch {
    return false;
  }
}

export function shouldShowRequirements(userEmail) {
  if (REQUIREMENTS_ENABLED_FOR_ALL) return true;
  return hasRequirementsAccess(userEmail);
}

// Communications / PM Hub — POC allowlist (mirror compliance during preview)
export const COMMUNICATIONS_ADMINS = [
  'dd@oquli.ca',
  'su@oquli.ca',
  'pr@oquli.ca',
  'shivani101201@gmail.com',
];

export const COMMUNICATIONS_ENABLED_FOR_ALL = false;

export function hasCommunicationsAccess(userEmail) {
  if (!userEmail) return false;
  try {
    return COMMUNICATIONS_ADMINS.includes(String(userEmail).toLowerCase());
  } catch {
    return false;
  }
}

export function shouldShowCommunications(userEmail) {
  if (COMMUNICATIONS_ENABLED_FOR_ALL) return true;
  if (process.env.REACT_APP_DEV_MODE === 'true') return true;
  return hasCommunicationsAccess(userEmail);
}
